import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/colors/red.css";
import DatePicker from "react-multi-date-picker";
import { useState } from "react";
export default function EditModal({ index, contract, addEditContract }) {
  const unixToPersianDate = (unix) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(unix) * 1000).toLocaleDateString("fa-IR", options);
    date.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
    return date;
  };
  console.log("contract.expire_date_", contract.expiredate);
  const [expireTime, setExpireTime] = useState(unixToPersianDate(contract.expiredate));
  return (
    <>
      <div class="modal fade text-start" id={`edit-contract-${index}`}>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editContractLabel">
                ویرایش
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form
              onSubmit={(e) => {
                addEditContract(e, "edit", index);
              }}
            >
              <div class="modal-body d-flex flex-column">
                <div className="mt-3">
                  <label htmlFor="senfcode">کد صنفی</label>
                  <input type="number" name="senfcode" className="form-control" id="senfcode" defaultValue={contract.senfcode} />
                </div>
                <div className="mt-3">
                  <label htmlFor="agentfullname">نام</label>
                  <input type="text" name="agentfullname" className="form-control" id="agentfullname" defaultValue={contract.agentfullname} />
                </div>
                <div className="mt-3">
                  <label htmlFor="agencyname">نام املاک</label>
                  <input type="text" className="form-control" name="agencyname" id="agencyname" defaultValue={contract.agencyname} />
                </div>
                <div className="mt-3">
                  <label htmlFor="agencytell">تلفن املاک </label>
                  <input type="number" className="form-control" name="agencytell" id="agencytell" defaultValue={+contract.agencytell} />
                </div>
                <div className="mt-3">
                  <label htmlFor="agencymob">موبایل املاک </label>
                  <input type="number" className="form-control" name="agencymob" id="agencymob" defaultValue={+contract.agencymob} />
                </div>
                <div className="mt-3">
                  <label htmlFor="agentmainmob">موبایل </label>
                  <input type="number" className="form-control" name="agentmainmob" id="agentmainmob" defaultValue={+contract.agentmainmob} />
                </div>
                <div className="mt-3">
                  <label htmlFor="sms_request_count">تعداد درخواست پیامک</label>
                  <input type="number" className="form-control" id="sms_request_count" name="sms_request_count" defaultValue={+contract.sms_request_count} />
                </div>

                <div className="mt-3 w-100" style={{ padding: "15px 10px", width: "100%" }}>
                  <label htmlFor="expiredate">تاریخ پایان</label>
                  <div>
                    <DatePicker
                      className="red"
                      style={{ padding: "15px 10px", width: "100%" }}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      name="expiredate"
                      value={expireTime}
                      onChange={(e) => {
                        setExpireTime(e);
                      }}
                    />
                  </div>
                </div>

                <div class="form-check form-switch mt-3">
                  <label class="form-check-label" for="agency_state">
                    وضعیت املاک
                  </label>
                  <input class="form-check-input" name="agency_state" type="checkbox" id="agency_state" defaultChecked={parseInt(contract.agency_state)} />
                </div>
                <div class="form-check form-switch mt-3">
                  <label class="form-check-label" for="amlak_subscription_state">
                    وضعیت اشتراک
                  </label>
                  <input class="form-check-input" type="checkbox" id="subscribtion_state" name="subscribtion_state" defaultChecked={parseInt(contract.subscribtion_state)} />
                </div>
                <input type="text" hidden value={contract.editkey} name="editkey" />
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                  بستن
                </button>
                <button type="submit" class="btn btn-primary">
                  اضافه
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
